import React, {Component} from 'react'
import {connect} from 'react-redux'
import {createResource, deleteResource, getResource, updateResource} from '../../../data/actions/resource'
import LocalStorage from '../../../util/localStorage'
import Resources from '../../../data/services/resources'
import {Field, FieldsManager} from '../../../data/services/fields'
import {
    CREATE_PERM,
    DEFAULT_CRUD_STATE, DEFAULT_DATABASE_DATETIME_FORMAT, DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    DELETE_PERM,
    FIXED_ASSET_TYPES,
    UPDATE_PERM
} from '../../../util/util-constants'
import {
    checkPerm,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON, getLookup,
    getProp,
    longTableColumn,
    mergeDeep,
    saveTableColumns
} from '../../../common/util/util-helpers'
import ActiveFilters from "../../../common/components/resource-table/table-components/active-filters";
import TableSettingsPopOver from "../../../common/components/resource-table/table-components/table-settings-popover";
import TableCard from "../../../common/components/resource-table/table-components/table-card";
import TableFilters from "../../../common/components/resource-table/table-components/table-filters";
import ResourceTable from "../../../common/components/resource-table";
import Pagination from "../../../common/components/resource-table/table-components/pagination";
import NoRecords from "../../../common/components/no-records-found/no-records";
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import TableOptionsDialog from "../../../common/components/resource-table/table-components/table-options-dialog";
import TableCardFooter from "../../../common/components/resource-table/table-components/table-card-footer";
import {
    DEFAULT_QUERY_LIMIT, MAJOR_ACCOUNT_TYPE_EXPENSE, MAJOR_ACCOUNT_TYPE_ASSET, MAJOR_ACCOUNT_TYPE_INCOME,
    MAJOR_ACCOUNT_TYPE_LIABILITY,
} from '../../../common/util/util-consts'
import Button from '../../../common/components/button'
import Tippy from "@tippyjs/react";
import DocumentArrowDownIcon from "@heroicons/react/20/solid/DocumentArrowDownIcon";
import {download} from "../../../data/actions/download";
import {currentDate} from "../../../common/util/util-dates";
import {ArchiveBoxXMarkIcon, ArrowUturnLeftIcon} from "@heroicons/react/24/outline";
import ModalSaveResource from "../../../common/components/modal/modal-save-resource";
import moment from "moment-timezone";
import {numberWithCommas, numberWithCommasToBack} from "../../../util/util-formaters";

class AssetsAssetsTab extends Component {
    constructor(props) {
        super(props)
        this.pagePath = this.props.location.pathname.substring(1) + '_asset'

        this.state = {
            // Default state
            ...DEFAULT_CRUD_STATE,
            sortBy: 'FixedAsset',

            // Fields
            fields: this.getFields(),
            tableOptions: getDefaultTableOptions(this.getFields(), {
                behaviour: {
                    canAdjustWidth: true
                },
                style: {
                    condensed: true,
                },
            }, this.pagePath, this.props.translate),

            // Filter, and header fields
            queryFilterFields: this.getQueryFilterFields(),
        }

        this.state = mergeDeep(this.state, LocalStorage.rehydrateState(this.pagePath))
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.breakpoint !== this.props.breakpoint && this.props.breakpoint.index <= 1 && this.state.queryFilterFields.limit.value !== 10) {
            this.handleFilterInputChange('limit', 10)
        }
    }

    /** Data Events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: this.getQuery()
        }))
    }

    archiveResource = (item) => {
        this.setState({text: this.props.translate('message.are_you_sure_delete_AssetsAssets')}, () => {
            this.handleToggleConfirmDialog(() => {
                this.props.dispatch(deleteResource({
                    user: LocalStorage.get('user'),
                    query: Object.assign({
                        FixedAssetID: item.FixedAssetID
                    }, this.getQuery()),
                    errorMessage: true, successMessage: `${item.FixedAsset} deleted`,
                    resource: this.getResource(),
                    piggyResource: this.getResource()
                }))
                this.handleToggleConfirmDialog()
            }, item)
        })
    }

    unDisposeResource = (item) => {
        this.setState({text: this.props.translate('message.are_you_sure_un_dispose_Assets')}, () => {
            this.handleToggleConfirmDialog(() => {
                this.props.dispatch(deleteResource({
                    user: LocalStorage.get('user'),
                    query: Object.assign({
                        FixedAssetID: item.FixedAssetID
                    }, this.getQuery()),
                    errorMessage: true, successMessage: `${item.FixedAsset} undisposed`,
                    resource: Resources.AccountingAssetsDispose,
                    piggyResource: this.getResource()
                }))
                this.handleToggleConfirmDialog()
            }, item)
        })
    }

    restoreFromArchive = (item) => {
        this.setState({text: this.props.translate('message.are_you_sure_restore_AssetsAssets')}, () => {
            this.handleToggleConfirmDialog(() => {
                this.props.dispatch(updateResource({
                    user: LocalStorage.get('user'),
                    params: {
                        FixedAssetID: item.FixedAssetID,
                        ArchivedDate: 1
                    },
                    errorMessage: true, successMessage: `${item.FixedAsset} AssetsAssets restored`,
                    query: this.getQuery(),
                    resource: this.getResource(),
                    piggyResource: this.getResource()
                }))
                this.handleToggleConfirmDialog()
            }, item)
        })
    }

    downloadExcel = () => {
        this.props.dispatch(download({
            user: LocalStorage.get('user'),
            resource: this.getResource(),
            query: Object.assign({format: 'EXCEL', name: 'assets_' + currentDate() + '.xlsx'}, this.getQuery())
        }))
    }

    /** UI Events
     ================================================================= */
    handleToggleConfirmDialog = (submit) => {
        this.setState({
            confirmModal: submit,
            confirmDialog: !this.state.confirmDialog
        })
    }

    handleUpdateSort = (sortBy) => {
        this.setState({
            sortBy: sortBy,
            sort: (this.state.sortBy === sortBy) ? (this.state.sort === 'ASC' ? 'DESC' : 'ASC') : 'ASC'
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleUpdateOffset = (offset, num) => {
        this.setState({
            offset: offset,
            paginationPage: num
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleEditClick = (item) => {
        this.handleLinkClick(`/accounting-assets/${item.FixedAssetID}`)
    }

    handleLinkClick = (e) => {
        this.props.history.push(e)
    }

    handleFilterInputChange = (name, value) => {
        this.setState({
            queryFilterFields: FieldsManager.updateField(this.state.queryFilterFields, name, value),
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleClearFiltersClick = (excludeAdditional = []) => {
        const queryFilterFields = Object.assign({}, this.state.queryFilterFields)
        const defaultExcludedFields = ['limit']
        const excludedFields = defaultExcludedFields.concat(excludeAdditional)

        Object.values(queryFilterFields).filter(it => !excludedFields.includes(it.name)).forEach(it => {
            FieldsManager.updateField(queryFilterFields, it.name, '')
        })

        this.setState({
            queryFilterFields: queryFilterFields,
            offset: 0,
            paginationPage: 1
        }, () => {
            this.saveFilters()
            this.fetchData()
        })
    }

    handleSetTableColumnOptions = (columns) => {
        let tableOptions = Object.assign({}, this.state.tableOptions)

        tableOptions.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        this.setState({
            tableOptions,
            columnsModalOpen: false
        }, () => saveTableColumns(this.pagePath, tableOptions))
    }

    getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(this.getFields(), {}, this.props.translate)
    }

    handleToggleColumnSettingsDialog = () => {
        this.setState({
            columnsModalOpen: !this.state.columnsModalOpen
        })
    }

    setOptions = (options) => {
        this.setState({
            tableOptions: options
        }, () => saveTableColumns(this.pagePath, options))
    }

    handleToggleDisposeItem = (item = null) => {
        this.setState({selectedItem: item, isDisposeDialogVisible: !this.state.isDisposeDialogVisible});
    }
    /** Helpers
     ================================================================= */
    saveFilters = () => {
        LocalStorage.persistState(this.pagePath, this.state, ['sortBy', 'sort', 'limit', 'input', 'archived'])
    }

    getFields = () => {
        return {
            FixedAsset: new Field('FixedAsset', '', ['empty'], false, 'text'),
            AssetNumber: new Field('AssetNumber', '', ['empty'], false, 'text'),
            PurchaseOrderID: new Field('PurchaseOrderID', '', ['empty'], false, 'select-search'),
            StartingAmount: new Field('StartingAmount', '', ['empty'], false, 'money'),
            Amount: new Field('Amount', '', ['empty'], false, 'money'),
            SalvageAmount: new Field('SalvageAmount', '', ['empty'], false, 'money'),
            FixedAssetTypeID: new Field('FixedAssetTypeID', '', ['empty'], false, 'select', {}, {
                values: FIXED_ASSET_TYPES
            }),
            AssetTittleID: new Field('AssetTittleID', '', ['empty'], false, 'select', {}, {
                values: getLookup('AssetTittleID')
            }),
            SerialNumber: new Field('SerialNumber', '', ['empty']),
            PurchaseDate: new Field('PurchaseDate', '', ['empty'], false, 'date'),
            StartDate: new Field('StartDate', '', ['empty'], false, 'date'),
            EndDate: new Field('EndDate', '', ['empty'], false, 'date'),
            WarrantyExpirationDate: new Field('WarrantyExpirationDate', '', ['empty'], false, 'date'),
            Description: new Field('Description', '', [], false, 'text', {
                render: (item) => (
                    <div>{longTableColumn(item.Description)}</div>
                )
            }),
            IsSold: new Field('IsSold', '', [''], false, 'checkbox', {}),
            IsDeprecated: new Field('IsDeprecated', '', [''], false, 'checkbox', {}),
            IsDisposed: new Field('IsDisposed', '', [''], false, 'checkbox', {})
        }
    }

    getDisposeFields = (item = null) => {
        return {
            FixedAssetID: new Field('FixedAssetID', item?.FixedAssetID, [''], false, 'text', {hideDialog: true}),
            Date: new Field('Date', moment().format(DEFAULT_DATABASE_DATETIME_FORMAT), ['empty'], false, 'date', {addContainerClass:"col-span-3"}),
            Proceeds: new Field('Proceeds', '0', ['empty'], false, 'money', {addContainerClass:"col-span-3"}),
            ProceedsAccountID: new Field('ProceedsAccountID', '', ['empty'], false, 'select-search', {addContainerClass:"col-span-3"}),
            LossOnDisposalAccountID: new Field('LossOnDisposalAccountID', '', ['empty'], false, 'select-search', {addContainerClass:"col-span-3"}),
            GainOnDisposalAccountID: new Field('GainOnDisposalAccountID', '', ['empty'], false, 'select-search', {addContainerClass:"col-span-3"}),


            IsFinanced: new Field('IsFinanced', '', [], false, 'checkbox', {addContainerClass:"col-span-3"}),
            FinanceLoss: new Field('FinanceLoss', '', [''], false, 'hidden', {addContainerClass:"col-span-3"}),
            FinanceAccountID: new Field('FinanceAccountID', '', [''], false, 'hidden', {addContainerClass:"col-span-3"}),
        }
    }

    getQueryFilterFields = () => {
        return {
            query: new Field('query', '', [''], false, 'search', {}, {}),
            showSold: new Field('showSold', '', [''], false, 'checkbox'),
            hideDeprecated: new Field('hideDeprecated', 1, [''], false, 'checkbox'),
            HideDisposed: new Field('HideDisposed', 1, [''], false, 'checkbox'),
            limit: new Field('limit', DEFAULT_QUERY_LIMIT, [''], false, 'select', {hideLabel: true}, {menuPlacement: 'top'}),
        }
    }

    getQuery = () => {
        return {
            sort: this.state.sort,
            sortBy: this.state.sortBy,
            offset: this.state.offset,

            ...FieldsManager.getFieldKeyValues(this.state.queryFilterFields)
        }
    }

    getResource = () => {
        return Resources.AssetsAssets
    }

    handleInputChangeDispose = (fields, name, value) => {
        fields = FieldsManager.updateField(fields, name, value)


        if (name === 'IsFinanced') {
           fields.FinanceLoss.type = value ? 'float' : 'hidden';
           fields.FinanceLoss.value = value ? 0 : null;
           fields.FinanceLoss.validate = value ? ['float'] : [''];
           fields.FinanceAccountID.type = value ? 'select-search' : 'hidden';
           fields.FinanceAccountID.value = null;
           fields.FinanceAccountID.validate = value ? ['empty'] : ['']
        }

        return fields
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props
        const data = getProp(resource.data, 'list', [])
        const count = getProp(resource.data, 'count', 0)
        const metadata = {
            ProceedsAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_ASSET,
                    ...DEFAULT_METADATA_SELECT_SEARCH_QUERY()
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            },
            LossOnDisposalAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_EXPENSE,
                    ...DEFAULT_METADATA_SELECT_SEARCH_QUERY()
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            },
            GainOnDisposalAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_INCOME,
                    ...DEFAULT_METADATA_SELECT_SEARCH_QUERY()
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            },
            FinanceAccountID: {
                api: 'api/' + Resources.AccountsQuick,
                query: {
                    MainAccountTypeID: MAJOR_ACCOUNT_TYPE_LIABILITY,
                    ...DEFAULT_METADATA_SELECT_SEARCH_QUERY()
                },
                searchMap: (item) => ({
                    label: item.AccountNumber + ' ' + item.AccountName,
                    value: item.AccountID
                })
            },
        }
        return (
            <React.Fragment>
                <div className="sm:flex mb-2">
                    <ActiveFilters
                        filterFields={this.state.queryFilterFields}
                        onLabelClick={this.handleFilterInputChange}
                        onClearFiltersClick={this.handleClearFiltersClick}
                        translate={translate}
                    />

                    <div className="ml-auto flex sm:justify-start justify-end items-center">
                        <Tippy content={translate('text.download_excel')}>
                            <button
                                className="btn-icon"
                                onClick={this.downloadExcel}
                            >
                                <DocumentArrowDownIcon className="w-5 h-5"/>
                            </button>
                        </Tippy>

                        <div className={'flex mr-4'}>
                            <TableSettingsPopOver
                                options={this.state.tableOptions}
                                setOptions={this.setOptions}
                                toggleColumnSettingsDialog={this.handleToggleColumnSettingsDialog}
                                translate={translate}
                            />
                        </div>

                        <Button
                            hasPerm={checkPerm(this.getResource(), CREATE_PERM)}
                            className={`btn btn-primary`}
                            onClick={() => this.handleLinkClick('/accounting-assets/create')}
                        >
                            {translate('btn.create_new')}
                        </Button>
                    </div>
                </div>

                <TableCard addClass={'relative'}>
                    <TableFilters
                        hideLimit
                        filterFields={this.state.queryFilterFields}
                        handleInputChange={this.handleFilterInputChange}
                        translate={translate}
                        onRefreshTable={this.fetchData}
                        isLoading={resource.isLoading}
                    />

                    <ResourceTable
                        data={data}
                        fields={this.getFields()}
                        verticalTableIsVisible={this.props.breakpoint.index <= 1}

                        translate={translate}
                        isLoading={resource.isLoading}

                        options={this.state.tableOptions}

                        limit={this.state.queryFilterFields.limit.value}

                        sort={this.state.sort}
                        sortBy={this.state.sortBy}
                        onSortChange={this.handleUpdateSort}

                        onRowClick={checkPerm(this.getResource(), UPDATE_PERM) ? this.handleEditClick : null}
                        onEdit={checkPerm(this.getResource(), UPDATE_PERM) ? this.handleEditClick : null}
                        onDelete={checkPerm(this.getResource(), DELETE_PERM) ? this.archiveResource : null}

                        actions={[
                            {
                                action: (it) => this.handleToggleDisposeItem(it),
                                icon: ArchiveBoxXMarkIcon,
                                visible: (it) => (checkPerm(Resources.AccountingAssetsDispose, CREATE_PERM) && (!it.IsSold && !it.IsDisposed)),
                                label: false,
                                title: translate('btn.dispose'),
                                order: 30
                            },
                            {
                                action: this.unDisposeResource,
                                icon: ArrowUturnLeftIcon,
                                visible: (it) => (checkPerm(Resources.AccountingAssetsDispose, DELETE_PERM) && !!it.IsDisposed),
                                label: false,
                                title: translate('btn.undispose'),
                                order: 40
                            }
                        ]}
                    />

                    {/*Table footer*/}
                    <TableCardFooter
                        show={!(!data.length && !resource.isLoading)}
                    >
                        <Pagination
                            count={count}
                            isLoading={resource.isLoading}
                            hideRowsPerPage={this.props.breakpoint.index <= 1}
                            handleQueryChange={
                                (name, value, currentPage) => name === 'offset'
                                    ? this.handleUpdateOffset(value, currentPage)
                                    : this.handleFilterInputChange(name, value)
                            }
                            pageOffset={this.state.offset}
                            queryFields={this.state.queryFilterFields}
                            translate={translate}
                        />
                    </TableCardFooter>

                    <NoRecords
                        show={(data.length === 0) && !resource.isLoading}
                        title={translate('text.no_records')}
                        addClass={'pt-16 pb-10'}
                    />
                </TableCard>

                <ModalConfirm
                    title={'Confirm'}
                    widthClass="max-w-2xl"
                    textClassName={"text-base text-tm-gray-900 word-break"}
                    show={!!this.state.confirmDialog}
                    text={this.state.text}
                    onClose={() => this.setState({confirmDialog: false})}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={this.state.confirmModal}
                />

                <TableOptionsDialog
                    show={this.state.columnsModalOpen}
                    pagePath={this.pagePath}
                    columns={this.state.tableOptions.columns}
                    setTableColumnOptions={this.handleSetTableColumnOptions}
                    getDefaultTableColumnOptions={this.getDefaultTableColumnOptions}
                    onClose={this.handleToggleColumnSettingsDialog}
                    translate={translate}
                />

                <ModalSaveResource
                    show={this.state.isDisposeDialogVisible}
                    title={translate('title.Dispose')}
                    widthClass="max-w-md"
                    gridColsClass="grid-cols-3"
                    onClose={this.handleToggleDisposeItem}
                    fields={this.getDisposeFields(this.state.selectedItem)}
                    onSubmit={(params) => {
                        if (params) {
                            this.props.dispatch(createResource({
                                user: LocalStorage.get('user'),
                                query: this.getQuery(),
                                params: params,
                                resource: Resources.AccountingAssetsDispose,
                                piggyResource: this.getResource(),
                                successMessage: 'Item disposed',
                                errorMessage: true
                            }))
                            this.handleToggleDisposeItem(null)
                        }
                    }}
                    handleInputChange={this.handleInputChangeDispose}
                    translate={this.props.translate}
                    metadata={metadata}
                />
            </React.Fragment>
        )
    }
}

export default connect(state => state)(AssetsAssetsTab)
